// extracted by mini-css-extract-plugin
export default {"button":"PdfsDisabledSnackBar_button__JnPIl"};